import React, { Component } from 'react';
import ConfigurationService from './services/Offices.service';
import Office from './models/Office';
import OfficesOverviewPage from './views/pages/OfficesOverviewPage'
import ContentModel from './models/ContentModel';


type AppProps = {
  content: ContentModel
}

type AppState = {
  offices: Office[],
}

export default class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      offices: [],
    };
  }

  public async componentDidMount() {
    const service: ConfigurationService = new ConfigurationService();
    const offices: Office[] = await service.getOffices();

    this.setState({
      offices: offices
    })
  }

  public render() {
    return (
      <>
        {
          <OfficesOverviewPage offices={this.state.offices} content={this.props.content} ></OfficesOverviewPage>
        }
      </>
    );
  }
}